import { Hero } from '@/components/landing/Hero';
import { Features } from '@/components/landing/Features';
import { HowItWorks } from '@/components/landing/HowItWorks';
import { Safety } from '@/components/landing/Safety';
import { PricingPreview } from '@/components/landing/PricingPreview';
import { AnalyzerPromo } from '@/components/landing/AnalyzerPromo';
import { Community } from '@/components/landing/Community';
import { SocialProof } from '@/components/landing/SocialProof';
import { FinalCta } from '@/components/landing/FinalCta';
import { Seo } from '@/components/seo/Seo';

export function LandingPage() {
  return (
    <>
      <Seo
        title="Clancy Tuning — AI-Assisted ECU Tuning, Engineered for Safety"
        description="AI-assisted ECU tuning workbench with deterministic three-tier safety, 3D map visualization, and a datalog analyzer. Free for Windows and macOS."
      />
      <Hero />
      <Features />
      <HowItWorks />
      <Safety />
      <PricingPreview />
      <AnalyzerPromo />
      <Community />
      <SocialProof />
      <FinalCta />
    </>
  );
}
